import script from "./RecommendEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendEdit.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendEdit.vue?vue&type=style&index=0&id=0003d9c1&lang=scss&scoped=true"
import "./RecommendEdit.vue?vue&type=style&index=1&id=0003d9c1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0003d9c1"]])

export default __exports__